import React from 'react'
import { Map, Marker } from 'react-amap';

export default function LocationMap(props) {
    const {center, position, add, pic } = props.location;
    const centerArr = [center.lng, center.lat];
    console.log('centerArr', centerArr)
    return (
        <div className='contacts_locationContainer'>
            {/* 地图 */}
            <div>
                <div className='contacts_mapContainer'>
                    <Map zoom={18} center={centerArr} viewMode={'3D'} amapkey='ed09e805dd2b632a8fc17d098436250a'>
                        <Marker position={centerArr}></Marker>
                    </Map>
                </div>
                <div className='contacts_mapAddress'>
                    <span>
                        {add}
                    </span>
                </div>
            </div>
            {/* 照片 */}
            <div className="location_company_image">
                {pic.map((item, index) => {
                    const src = `${process.env.PUBLIC_URL}/images/contacts/${item}`
                    console.log('src', src)
                    return <img key={index} className='contacts_img' src={src} alt='' />
                })}
            </div>
        </div>
    )
}
